import {
  getBooklistBookCount as getBooklistBookCountFromTemplates,
  createCollectionCardHtml as createCollectionCardHtmlFromTemplates,
  createCollectionCurrentCardHtml as createCollectionCurrentCardHtmlFromTemplates,
  createCollectionActionCardHtml as createCollectionActionCardHtmlFromTemplates,
  createCollectionListItemHtml as createCollectionListItemHtmlFromTemplates,
  createCollectionCurrentListItemHtml as createCollectionCurrentListItemHtmlFromTemplates,
  createCollectionActionListItemHtml as createCollectionActionListItemHtmlFromTemplates,
  createBooklistActionCardHtml as createBooklistActionCardHtmlFromTemplates,
  createBooklistActionListItemHtml as createBooklistActionListItemHtmlFromTemplates
} from './bookshelfCardTemplatesModule.js';
import {
  filterBooks as filterBooksByShelfState,
  sortBooksForBooklist as sortBooksForBooklistByState,
  sortBooklists as sortBooklistsByState,
  sortBooks as sortBooksByState,
  sortCollections as sortCollectionsByState,
  getFilteredCollectionsForShelf as getFilteredCollectionsForShelfByState
} from './shelfFilterSortModule.js';
import {
  getNextCustomSortOrderByBooks
} from './shelfSortInteractionModule.js';
import {
  createBookCard as createBookCardFromTemplates,
  createBookListItem as createBookListItemFromTemplates
} from './bookshelfBookTemplatesModule.js';
import {
  buildCollectionShelfHeaderHtml as buildCollectionShelfHeaderHtmlHelper
} from './bookshelfRenderHelpersModule.js';

export function createShelfPresentationFacade(context = {}) {
  const {
    state,
    escapeHtml
  } = context;

  function getBooklistBookCount(booklistId) {
    return getBooklistBookCountFromTemplates(state, booklistId);
  }

  function createCollectionCardHtml(collection) {
    return createCollectionCardHtmlFromTemplates(state, escapeHtml, collection);
  }

  function createCollectionCurrentCardHtml(collection) {
    return createCollectionCurrentCardHtmlFromTemplates(state, escapeHtml, collection);
  }

  function createCollectionActionCardHtml(action, label, subtitle = '', meta = '') {
    return createCollectionActionCardHtmlFromTemplates(escapeHtml, action, label, subtitle, meta);
  }

  function createCollectionListItemHtml(collection) {
    return createCollectionListItemHtmlFromTemplates(state, escapeHtml, collection);
  }

  function createCollectionCurrentListItemHtml(collection) {
    return createCollectionCurrentListItemHtmlFromTemplates(state, escapeHtml, collection);
  }

  function createCollectionActionListItemHtml(action, label, subtitle = '', meta = '') {
    return createCollectionActionListItemHtmlFromTemplates(escapeHtml, action, label, subtitle, meta);
  }

  function createBooklistActionCardHtml(action, label, subtitle = '', meta = '') {
    return createBooklistActionCardHtmlFromTemplates(escapeHtml, action, label, subtitle, meta);
  }

  function createBooklistActionListItemHtml(action, label, subtitle = '', meta = '') {
    return createBooklistActionListItemHtmlFromTemplates(escapeHtml, action, label, subtitle, meta);
  }

  function filterBooks(books) {
    return filterBooksByShelfState(books, state);
  }

  function sortBooksForBooklist(books, orderedIds = [], sortKey = 'custom') {
    return sortBooksForBooklistByState(books, orderedIds, sortKey);
  }

  function sortBooklists(lists, sortKey = 'custom') {
    return sortBooklistsByState(lists, sortKey, state);
  }

  function sortBooks(books) {
    return sortBooksByState(books, state);
  }

  function sortCollections(collections) {
    return sortCollectionsByState(collections, state);
  }

  function getFilteredCollectionsForShelf() {
    return getFilteredCollectionsForShelfByState(state);
  }

  function getNextCustomSortOrder() {
    return getNextCustomSortOrderByBooks(state.books);
  }

  function createBookCard(book) {
    return createBookCardFromTemplates(book, {
      isSelectMode: state.isSelectMode,
      selectedBookIds: state.selectedBooks
    });
  }

  function createBookListItem(book) {
    return createBookListItemFromTemplates(book);
  }

  function buildCollectionShelfHeaderHtml(isGrid) {
    return buildCollectionShelfHeaderHtmlHelper({
      state,
      isGrid,
      getFilteredCollectionsForShelf,
      createCollectionActionCardHtml,
      createCollectionCurrentCardHtml,
      createCollectionActionListItemHtml,
      createCollectionCurrentListItemHtml,
      createCollectionCardHtml,
      createCollectionListItemHtml
    });
  }

  return {
    getBooklistBookCount,
    createCollectionCardHtml,
    createCollectionCurrentCardHtml,
    createCollectionActionCardHtml,
    createCollectionListItemHtml,
    createCollectionCurrentListItemHtml,
    createCollectionActionListItemHtml,
    createBooklistActionCardHtml,
    createBooklistActionListItemHtml,
    filterBooks,
    sortBooksForBooklist,
    sortBooklists,
    sortBooks,
    sortCollections,
    getFilteredCollectionsForShelf,
    getNextCustomSortOrder,
    createBookCard,
    createBookListItem,
    buildCollectionShelfHeaderHtml
  };
}
